export function linkToHomePage() {
  return "/";
}
